module.exports = __webpack_public_path__ + "static/feature_3-c602ed8918068b179697e8d4f7e6f87b.png";